import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card.js';

export type DataCardRow = [label: string, value: ReactNode];

export function DataCard({ title, rows }: { title: string; rows: DataCardRow[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-2 text-sm">
          {rows.map(([label, value], idx) => (
            <div
              // label may repeat across rows in edge cases — index makes the key safe
              key={`${label}-${idx}`}
              className="grid grid-cols-[140px_1fr] gap-2 border-b border-[var(--border)]/50 pb-1.5"
            >
              <dt className="text-[var(--muted-foreground)]">{label}</dt>
              <dd className="font-medium break-words">
                {value === null || value === undefined || value === '' ? '—' : value}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
